import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '作品分类',
    links: [
      { label: '精选推荐', href: '/category/featured' },
      { label: '经典系列', href: '/category/classic' },
      { label: '最新作品', href: '/category/latest' },
      { label: '高分好评', href: '/category/top-rated' },
      { label: '独家珍藏', href: '/category/exclusive' },
    ],
  },
  {
    title: '快速导航',
    links: [
      { label: '网站首页', href: '/' },
      { label: '影评文章', href: '/article/1' },
      { label: '观影指南', href: '/article/5' },
      { label: '关于我们', href: '/about' },
    ],
  },
  {
    title: '帮助中心',
    links: [
      { label: '常见问题', href: '/#faq' },
      { label: '观影指南', href: '/article/5' },
      { label: '联系我们', href: '/about#contact' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-background-950 text-background-200" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-2 cursor-pointer">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-film-line text-xl text-background-50"></i>
              </div>
              <span className="font-heading font-bold text-background-50 text-lg whitespace-nowrap">
                北条麻妃电影
              </span>
            </Link>
            <p className="mt-4 text-sm text-background-400 leading-relaxed">
              最全面的北条麻妃电影作品全集资源导航平台，为影迷提供高清影片信息与观影指南。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-all duration-200 cursor-pointer"
                aria-label="QQ"
                rel="nofollow"
              >
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading font-semibold text-background-50 text-sm mb-4">
                {group.title}
              </h3>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.href}
                      className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 北条麻妃电影全集精选. 保留所有权利.
          </p>
          <div className="flex items-center gap-4 text-xs text-background-500">
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap" rel="nofollow">
              使用条款
            </a>
            <a href="/about#contact" className="hover:text-primary-400 transition-colors duration-200 whitespace-nowrap">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}